<div class="land-modal">
  <div class="land-modal-header">
    <h3>{{ title }}</h3>
  </div>
  <div class="land-modal-body">
    <p>{{ text }}</p>
  </div>
  <div class="land-modal-footer">
    <button class="land-button land-button_green" (click)="redirectToParentSite()">
      <span> {{buttonTitle}} </span>
    </button>
  </div>
</div>
